<template>
  <div class="modal-overlay">
    <div class="modal-background" />
    <div class="modal">
      <div class="modal-image">
        <img :src="require('../../../public/assets/demo_user.svg')" alt="demo">
      </div>
      <div class="title">
        <h1 class="modal-title">Hi {{ userFullName }},</h1>
      </div>
      <div class="description">
        Thank you for creating your CoreEvent account! Your account is currently in <span class="bold-tag">demo mode</span>, allowing you to explore
        the platform’s basic features.
      </div>
      <div class="modal-body">
        <div>
          Unlock the full potential of CoreEvent and take your experience to the next level! The full version includes:
        </div>
        <div>
          <ul style="list-style-type: none;">
            <li>
              •&nbsp;&nbsp;Creating <span class="bold-tag">multiple events</span> to expand your reach,
            </li>
            <li>
              •&nbsp;&nbsp;<span class="bold-tag">Publishing events</span> to share them with your audience,
            </li>
            <li>
              •&nbsp;&nbsp;<span class="bold-tag">Sending emails to attendees</span> for seamless communication,
            </li>
            <li>
              •&nbsp;&nbsp;<span class="bold-tag">Additional features</span> to enhance your event management experience.
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-notice">
        Contact our team at <a class="mail-to-link" href="mailto:support@core-event.co">support@core-event.co</a> for
        quick verification and approval. If you’re already in touch with someone from our team, feel free to reach out
        to them directly.
      </div>
      <div class="button-container">
        <main-button style="width: 175px" flat type="button" @click.stop="$emit('close')"> SKIP FOR NOW</main-button>
        <main-button style="width: 314px" type="button">
          <a href="mailto:support@core-event.co" style="text-decoration: none; color: inherit;">CONTACT SUPPORT</a>
        </main-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['close'],
  // eslint-disable-next-line vue/require-prop-types
  props: ['user'],
  computed: {
    userFullName() {
      return `${this.user.firstName} ${this.user.lastName}`
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}

.mail-to-link {
  color: inherit;
  text-decoration: underline;
}

.modal {
  text-align: center;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 549px;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.modal ul {
  margin: 0 auto;
}

.modal::-webkit-scrollbar {
  display: none;
}

.modal-image {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.bold-tag {
  font-weight: 800;
}

.modal-title {
  font-variant-numeric: lining-nums proportional-nums;
  font-family: 'Raleway';
  font-style: normal;
  line-height: 120%;
  letter-spacing: -0.0375rem;
  color: #666666;
  font-size: 36px;
  font-weight: 800;
}

.modal-notice {
  margin-top: 2rem;
  color: #666666;
  font-family: 'Source Sans Pro';
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}

.modal-body {
  color: #666666;
  font-family: 'Source Sans Pro';
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}

@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}

.title {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}


.description {
  color: #666666;
  font-family: 'Source Sans Pro';
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

@media screen and (max-width: 700px) {
  .button-container {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .button-container main-button {
    width: 100%;
    margin-bottom: 1rem;
  }
}
</style>
